<template>
  <div>
    <el-form ref="form" label-width="120px">
      <el-form-item label="在线验证码：">
        <div class="code-box">
          <div>
            <div class="code-text">
              <span style="margin-right: 8px">{{codeForm.chsiCode}}</span>
              <span class="copy-btn" :data-clipboard-text="codeForm.chsiCode" ref="copy" @click="copyFrom">复制</span>
            </div>
            <p class="chis-web">验证页面：<span class="web-link" @click="goChisWeb">{{webUrl}}</span></p>
          </div>
          <el-button type="primary" @click="goChisReport" style="margin-right: 20px">验证报告</el-button>
        </div>
      </el-form-item>
      <el-form-item label="审核结果：">
        <el-radio-group v-model="state" @change="stateChange">
          <el-radio-button :label="2">通过</el-radio-button>
          <el-radio-button :label="3">不通过</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="不通过原因：" v-show="state == 3">
        <el-input type="textarea" v-model="codeForm.remark" rows="4" placeholder="" style="width:30em;"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button size="medium" @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="submit" v-loading="submitLoading">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { updateStateChsi } from "@/api/url";
import { postFormData } from "@/api/api";
import Clipboard from "clipboard";
export default {
name: "educationCodeDialog",
  props: {
    value: Object
  },
  data() {
    return {
      codeForm: this.value.codeForm,
      webUrl: 'https://www.chsi.com.cn/xlcx/bgcx.jsp',
      state: this.value.codeForm.eduState,
      clipboard: null,
      submitLoading: false,
    }
  },
  methods: {

    stateChange(val) {
      if(val == 2) this.codeForm.remark = ''
      if(val == 3) this.codeForm.remark = '认证失败，学历信息与实名信息不相符'
    },

    //返回
    cancel() {
      this.$emit('close');
    },

    goChisReport() {
      let url = 'https://www.chsi.com.cn/xlcx/bg.do?vcode=' + this.codeForm.chsiCode + '&srcid=bgcx'
      window.open(url)
    },

    goChisWeb() {
      window.open(this.webUrl)
    },

    //复制
    copyFrom(){
      this.clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        this.clipboard.destroy() //使用destroy可以清除缓存
        this.clipboard = new Clipboard(this.$refs.copy)
      })
      this.clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        this.clipboard.destroy()
        this.clipboard = new Clipboard(this.$refs.copy)
      })
    },
    submit() {
      if(this.state != 2 && this.state !=3) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请选择审核结果',
          type: 'warning'
        });
        return false
      }
      this.submitLoading = true
      let params = {
        id: this.codeForm.id,
        eduState: this.state,
        remark: this.codeForm.remark
      }
      postFormData(updateStateChsi, params).then(data => {
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
        this.submitLoading = false
      }).catch(()=> {
        this.submitLoading = false
      })
    },

  },
  mounted() {
    this.clipboard = new Clipboard(this.$refs.copy)
  },
  unmounted() {
    this.clipboard.destroy()
  }
}
</script>

<style scoped>
.code-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.code-text {
  display: flex;
  align-items: center;
}
.copy-btn {
  color: #409eff;
  cursor: pointer;
}
.chis-web {
  line-height: 1;
  font-size: 12px;
  color: #aaaaaa;
  margin-bottom: 8px;
}
.web-link:hover{
  color: #409eff;
  cursor: pointer;
}

</style>
